// Side-effect module: registers the `creatorCode` namespace into i18next.
// Imported by CreatorCodeField so the strings ship with it. Same
// ordering-safe pattern as registerVocalConfirmI18n.ts.
import i18n from "../i18n";
import creatorCode from "./creatorCode";

for (const [code, data] of Object.entries(creatorCode)) {
  i18n.addResourceBundle(
    code,
    "translation",
    { creatorCode: data },
    true,
    true,
  );
}
